import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { actions as changeSettingsActions } from '../../../redux/profiles/change-settings';
import { actions as editUserActions } from '../../../redux/profiles/edit-user';
import {
  canEditNotJoinedPatient,
  canEditPatient,
  targetUserSelector,
} from '../../../redux/context/selectors';
import styles from '../index.styl';

const mapStateToProps = state => ({
  profile: targetUserSelector(state),
  canEdit: canEditPatient(state),
  canEditOwnPatient: canEditNotJoinedPatient(state),
});

const mapDispatchToProps = {
  saveUser: editUserActions.send,
  saveSettings: changeSettingsActions.send,
};
export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileSettings/enhance.js